import { useState } from "react";
import { Sparkles, Plus, Check, Loader2, ChevronDown } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

function buildTemplates() {
  const t = [
    { id: "pl-prep", group: "Property Lines", title: "Prep property lines the day before",
      text: "When a Property Lines product is due tomorrow and still new, remind me" },
    { id: "fp-prep", group: "Floor Plans", title: "Floor plan due tomorrow check",
      text: "When a Floor Plans product is due tomorrow and still new, remind me" },
    { id: "notphotos-unassigned", group: "If not", title: "Unassigned booking, skip plain photos",
      text: "When a new order is booked and unassigned, if not Photos, remind me" },
    { id: "due-unless-ready", group: "If not", title: "Due tomorrow unless it's Ready",
      text: "When a product is due tomorrow, unless it's Ready, remind me" },
    { id: "shoot-eve-email", group: "Photographers", title: "Email the photographer the day before",
      text: "The day before a shoot, email the photographer" },
    { id: "shoot-resched", group: "Photographers", title: "Shoot rescheduled heads-up",
      text: "When a shoot is rescheduled, remind me" },
    { id: "digest-unless-ready", group: "If not", title: "Morning email, leave out Ready items",
      text: "Every weekday at 7am email me today's due products unless it's Ready" },
    { id: "tour-today", group: "3D Tours", title: "3D tour due today, still new",
      text: "When a 3D Tours product is due today and still new, remind me" },
    { id: "video-prep", group: "Video", title: "Video due tomorrow heads-up",
      text: "When a Video product is due tomorrow, remind me" },
    { id: "unassigned", group: "Orders", title: "New booking with nobody assigned",
      text: "When a new order is booked and unassigned, remind me" },
    { id: "digest", group: "Daily", title: "Weekday morning email of today's due products",
      text: "Every weekday at 7am email me today's due products" },
  ];
  return t;
}

const TemplateCard = ({ t, added, busy, onAdd }) => (
  <div className="flex flex-col justify-between gap-3 rounded-xl border border-border bg-card p-4" data-testid={`automation-template-${t.id}`}>
    <div>
      <div className="text-[10px] font-semibold uppercase tracking-wider text-primary">{t.group}</div>
      <div className="mt-1 text-sm font-medium">{t.title}</div>
      <p className="mt-1 text-xs text-muted-foreground">“{t.text}”</p>
    </div>
    <button onClick={() => onAdd(t)} disabled={added || busy} data-testid={`automation-template-add-${t.id}`}
      className={`inline-flex h-8 items-center justify-center gap-1.5 rounded-md border px-3 text-xs font-semibold transition-colors disabled:cursor-default ${added ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-400" : "border-primary/40 bg-primary/10 text-primary hover:bg-primary/20"}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : added ? <Check className="h-3.5 w-3.5" /> : <Plus className="h-3.5 w-3.5" />}
      {added ? "Added" : "Add automation"}
    </button>
  </div>
);

export const AutomationTemplates = ({ existing, onAdded }) => {
  const [templates] = useState(buildTemplates);
  const [busy, setBusy] = useState(null);
  const [open, setOpen] = useState(() => localStorage.getItem("starterAutomationsOpen") !== "0");
  const toggle = () => setOpen((o) => { localStorage.setItem("starterAutomationsOpen", o ? "0" : "1"); return !o; });

  const have = new Set((existing || []).map((a) => a.text.trim().toLowerCase()));
  const add = async (t) => {
    setBusy(t.id);
    try {
      await api.post("/automations", { text: t.text, name: t.title });
      toast.success(`Added “${t.title}”`);
      onAdded();
    } catch (err) { toast.error(apiError(err)); }
    setBusy(null);
  };

  if (!templates.length) return null;
  return (
    <div className="rounded-xl border border-border bg-secondary/10 p-4" data-testid="automation-templates">
      <button onClick={toggle} aria-expanded={open} data-testid="automation-templates-toggle"
        className="flex w-full items-center gap-2 text-left text-sm font-semibold">
        <Sparkles className="h-4 w-4 text-primary" /> Starter automations
        <span className="text-xs font-normal text-muted-foreground">({templates.length})</span>
        <ChevronDown className={`ml-auto h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="mt-3 grid gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="automation-templates-grid">
        {templates.map((t) => (
          <TemplateCard key={t.id} t={t} added={have.has(t.text.toLowerCase())} busy={busy === t.id} onAdd={add} />
        ))}
      </div>}
    </div>
  );
};
